var exports = {
  "I": "x9245d464--a29897--seo-text",
  "R": "x9245d464--a29897--fake-label",
};

module.exports = exports;
